import type { TeamMemberForJobAccess } from '@seek/hirer-team-member-job-access';

import {
  type ActorContext,
  type HeaderFooterContext,
  PostType,
  JobStatus,
  Permission,
  DraftStatus,
  type JobListItemFragment,
  type DraftJobListItemFragment,
  AnalyticsAdRatingScore,
  AnalyticsAdRatingStatus,
  type JobsListFragment,
} from 'src/graphql/__generated__';

export const MOCK_JOB: JobListItemFragment = {
  id: '12345',
  title: 'Senior Full Stack Developer',
  candidatesCount: 250,
  newCandidatesCount: 2,
  status: JobStatus.ACTIVE,
  daysRemaining: 10,
  postType: PostType.DIRECT,
  locations: [
    {
      description: 'Melbourne, VIC 3000',
      country: 'au',
    },
  ],
  createdDate: '2021-06-30T02:34:56Z',
  owner: {
    fullName: 'Caitlin Doe',
  },
  canBeRefreshed: true,
  canBeUpgraded: false,
  payPerPlacementEligibility: {
    __typename: 'PayPerPlacementNonEligibleResponse',
  },
};

export const singleAdminTeamMembers: TeamMemberForJobAccess[] = [
  {
    userId: '1253',
    firstName: 'Jacob20',
    lastName: 'Wine',
    email: 'minion20@seek.com.au',
    isPending: false,
    hasAccessToAllJobs: false,
    hasAccessToCurrentJob: true,
    isJobCreator: false,
    isAdmin: true,
    accessSelected: false,
    notifySelected: false,
  },
];

export const multiAdminTeamMembers: TeamMemberForJobAccess[] = [
  {
    userId: '1253',
    firstName: 'Jacob20',
    lastName: 'Wine',
    email: 'minion20@seek.com.au',
    isPending: false,
    hasAccessToAllJobs: false,
    hasAccessToCurrentJob: true,
    isJobCreator: false,
    isAdmin: true,
    accessSelected: false,
    notifySelected: false,
  },
  {
    userId: '1252',
    firstName: 'Jacob21',
    lastName: 'Wine',
    email: 'minion21@seek.com.au',
    isPending: false,
    hasAccessToAllJobs: false,
    hasAccessToCurrentJob: true,
    isJobCreator: false,
    isAdmin: true,
    accessSelected: false,
    notifySelected: false,
  },
  {
    userId: '1251',
    firstName: 'Jacob22',
    lastName: 'Wine',
    email: 'minion22@seek.com.au',
    isPending: false,
    hasAccessToAllJobs: false,
    hasAccessToCurrentJob: true,
    isJobCreator: false,
    isAdmin: false,
    accessSelected: false,
    notifySelected: false,
  },
];

export const devAccountHeaderInfo_act: ActorContext = {
  __typename: 'ActorContext',
  operatorEmail: 'operator@email.com',
  csToggleHref: 'http://toggle.cs.com',
  isCsView: true,
};
export const devAccountHeaderInfo: HeaderFooterContext = {
  identityContext: {
    __typename: 'IdentityHeaderContext',
    email: 'email@gmail.com',
    act: null,
  },
  advertiser: {
    __typename: 'AdvertiserHeaderContext',
    hasMultipleAccounts: true,
    name: 'SEEK Test Account',
    billingId: '1234567',
    isActivationPending: false,
    isAgency: false,
    permissionOptions: {
      canClaimCompanyProfile: false,
      canCreateJobs: true,
      canManageBrand: true,
      canManageCompanyProfile: true,
      canManageUsers: true,
      canPayInvoices: true,
      canViewInvoiceHistory: true,
      canViewManagerReports: true,
      canViewInsightsRoleReport: true,
    },
    permissions: [
      Permission.payInvoices,
      Permission.viewInvoiceHistory,
      Permission.manageUsers,
      Permission.manageBrand,
      Permission.createJobs,
    ],
    showOnCreditHoldMessage: false,
    switchAccountsHref: '/oauth/integration/?#/?fn=loginWithScope', // null when single account
  },
  user: {
    __typename: 'UserHeaderContext',
    name: 'Lord Mockington',
    firstName: 'Lord',
    id: '123456',
  },
};

export const devUserId = 'auth0|123456';

export const MOCK_DRAFT: DraftJobListItemFragment = {
  id: '550e8400-e29b-41d4-a716-446655440000',
  owner: {
    fullName: 'Jane Bob',
  },
  createdDate: '2021-08-15T01:22:33Z',
  title: 'Senior Business Analyst',
  status: DraftStatus.OPEN,
  locationsV2: [
    {
      description: 'Cremorne',
    },
  ],
};

export const MOCK_JOBS_LIST: JobsListFragment = {
  __typename: 'JobsResponseSuccess',
  result: {
    edges: [
      {
        node: {
          __typename: 'Job',
          id: '1111',
          advertiserJobReference: 'Internal Reference',
          owner: {
            fullName: 'Jane Bob',
          },
          createdDate: '2024-09-06T07:26:28.677Z',
          listingDate: '2021-09-06T07:26:33.2Z',
          locations: [
            {
              country: 'au',
              description: 'All Adelaide, SA',
            },
          ],
          postType: PostType.DIRECT,
          status: JobStatus.ACTIVE,
          title: 'Job Title',
          daysRemaining: 11,
          performanceRating: {
            status: AnalyticsAdRatingStatus.AVAILABLE_WITH_RATING,
            score: AnalyticsAdRatingScore.NORMAL,
          },
          candidatesCount: 6,
          newCandidatesCount: 5,
          canBeUpgraded: false,
          canBeRefreshed: false,
          payPerPlacementEligibility: {
            __typename: 'PayPerPlacementNonEligibleResponse',
          },
        },
      },
    ],
    totalCount: 1,
  },
};
